var map = {
  "./edit": "99403",
  "./edit.js": "99403",
  "./index_active": "34304",
  "./index_active.js": "34304",
  "./index_discarded": "84459",
  "./index_discarded.js": "84459",
  "./index_pending": "27847",
  "./index_pending.js": "27847",
  "./new": "9953",
  "./new.js": "9953",
  "./show": "53082",
  "./show.js": "53082",
  "./tabs": "85387",
  "./tabs.js": "85387"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 2133;
